<script lang="ts" setup>
  type Props = {
    noFaq?: boolean
  }
  const props = defineProps<Props>()
  const emit = defineEmits<{
    (e: 'secondClick'): void
  }>()

  const router = useRouter()
  const { t } = useI18n()

  async function handleFirstLinkClick() {
    await router.push({ query: { modal: 'contact' } })
  }

  function handleSecondLinkClick() {
    emit('secondClick')
  }

</script>

<template>
  <div class="c-contact-block">
    <ActionBlock
      :no-faq="props.noFaq"
      centered
      top-icon="contact"
      :title="t('common.ask-question')"
      :main-link-name="t('common.contact-us')"
      main-link-url="?modal=contact"
      :second-link-name="t('common.read-our-faq')"
      second-link-url="/faq"
      @first-link-click="handleFirstLinkClick"
      @second-link-click="handleSecondLinkClick"
    />
  </div>
</template>

<style scoped>
.c-contact-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
  background-color: var(--color-secondary-light);
}
</style>
